<template>
<!--  <div class="full-screen-loader">-->
<!--    <smd-loader :style="computedStyles" :class="position" :image="$options.Logo"/>-->
<!--    <p>Text here...</p>-->
<!--  </div>-->
  <smd-loader :style="computedStyles" :class="position" :image="$options.Logo"/>
</template>

<script>
  import Logo from '@/assets/images/now-serving-heart.svg';

  export default {
    name: 'full-screen-loader',
    props: {
      position: {type: String, default: 'absolute'},
      whiteBg: {type: Boolean, default: false}
    },
    computed: {
      computedStyles() {
        return this.whiteBg ? {backgroundColor: 'white'} : ''
      }
    },
    Logo,
  }
</script>

<style lang="scss">
  .smd-loader-container {
    &.fixed {
      position: fixed !important;
    }
  }
</style>
